export const legislationData = {
  title: "Company Security and Usage Legislation",
  introduction:
    "Below are the legislative policies governing our security, resource usage, and vendor management to ensure legal compliance and operational integrity.",
  conclusion:
    "These legislation policies will be periodically reviewed and updated to align with evolving legal requirements and industry best practices.",
  data: [
    {
      id: 1,
      title: "Information Classification",
      description: (
        <>
          <mark
            style={{
              backgroundColor: "rgba(254, 122, 149, 0.20)",
              color: "#5c434b",
            }}
          >
            Classify information
          </mark>{" "}
          as Public, Internal, or Confidential.
        </>
      ),
      points: [
        {
          title: "Levels:",
          items: [
            "Public: unrestricted.",
            "Internal: employees only.",
            "Confidential: NDA required.",
          ],
        },
      ],
      note: "Review classification every 6 months.",
    },
    {
      id: 2,
      title: "Acceptable Use of Resources",
      description: (
        <>
          <mark
            style={{
              backgroundColor: "rgba(245, 148, 50, 0.2)",
              color: "rgb(85, 67, 50)",
            }}
          >
            Use resources
          </mark>{" "}
          only for official purposes; personal use is limited.
        </>
      ),
      points: [
        {
          title: "Guidelines:",
          items: [
            "Authorized software only.",
            "No illegal content.",
            "Fair bandwidth use.",
          ],
        },
      ],
      note: "Violations may lead to disciplinary action.",
    },
    {
      id: 3,
      title: "Password Management",
      description:
        "Passwords must be at least 12 characters with mixed case, numbers, and symbols.",
      points: [
        {
          title: "Rules:",
          items: [
            "Min length: 12.",
            "Include uppercase, lowercase, digits, symbols.",
            "Change every 90 days.",
          ],
        },
      ],
      note: "Do not reuse last 5 passwords.",
    },
    {
      id: 4,
      title: "Remote Work Security",
      description: "VPN required for remote access; public Wi‑Fi prohibited.",
      points: [
        {
          title: "Requirements:",
          items: ["VPN mandatory.", "Device encryption.", "Security updates."],
        },
      ],
      note: "Remote sessions monitored.",
    },
    {
      id: 5,
      title: "Third‑Party Vendor Management",
      description:
        "Vendors undergo security assessments and sign data protection agreements.",
      points: [
        {
          title: "Checks:",
          items: [
            "Annual audits.",
            "Data processing agreement.",
            "Incident reporting timeline.",
          ],
        },
      ],
      note: "Terminate non‑compliant vendors.",
    },
  ],
};

export const policiesAndProceduresData = {
  title: "General Data Protection Regulation (GDPR) Compliance Policy",
  introduction:
    "This document outlines the company’s compliance with the General Data Protection Regulation (GDPR), which is a regulation enacted by the European Union (EU) to protect the personal data and privacy of EU citizens. The company is committed to ensuring that all personal data is processed in compliance with GDPR.",
  conclusion:
    "This document serves as the company’s commitment to GDPR compliance. We continuously review our practices to ensure alignment with the latest data protection regulations and improve our data handling processes.",
  data: [
    {
      id: 1,
      title: "Data Collection and Consent",
      description: (
        <>
          <mark
            style={{
              backgroundColor: "rgba(254, 122, 149, 0.20)",
              color: "#5c434b",
            }}
          >
            We collect personal data only when necessary for the purpose of
            providing services.
          </mark>{" "}
          We will obtain explicit consent from individuals before collecting any
          personal data. The consent is recorded and can be withdrawn at any
          time.
        </>
      ),
      points: [
        {
          title: "Personal Data Collected:",
          items: [
            "Name",
            "Email Address",
            "Contact Information",
            "Payment Information",
          ],
        },
      ],
      note: "Consent must be freely given, informed, and specific.",
    },
    {
      id: 2,
      title: "Data Retention Policy",
      description: (
        <>
          <mark
            style={{
              backgroundColor: "rgba(245, 148, 50, 0.2)",
              color: "rgb(85, 67, 50)",
            }}
          >
            Personal data is retained only as long as necessary to fulfill the
          </mark>{" "}
          purpose for which it was collected or as required by law. We review
          the necessity of storing personal data annually and securely delete or
          anonymize data that is no longer needed.
        </>
      ),
      points: [
        {
          title: "Data Retention Period:",
          items: [
            "User data: Retained for 2 years after the last interaction.",
            "Transaction data: Retained for 5 years for legal and accounting purposes.",
          ],
        },
      ],
      note: "Data retention periods must be explicitly defined and documented.",
    },
    {
      id: 3,
      title: "Data Access and Security",
      description:
        "Access to personal data is restricted to authorized personnel only. All data is encrypted during transmission and storage. We regularly conduct security audits and vulnerability assessments to ensure data protection.",
      points: [
        {
          title: "Data Access Restrictions:",
          items: [
            "Only employees with a legitimate need to access personal data are granted access.",
            "All access to personal data is logged for auditing purposes.",
          ],
        },
      ],
      note: "Strong data protection measures must be implemented to safeguard personal data.",
    },
    {
      id: 4,
      title: "User Rights and Data Subject Access Requests",
      description:
        "Individuals have the right to access, correct, and delete their personal data at any time. We also provide the option for individuals to restrict the processing of their personal data.",
      points: [
        {
          title: "Rights of Data Subjects:",
          items: [
            "Right to Access",
            "Right to Rectification",
            "Right to Erasure",
            "Right to Restrict Processing",
          ],
        },
      ],
      note: "GDPR requires clear processes for responding to user rights requests.",
    },
    {
      id: 5,
      title: "Data Breach Notification",
      description:
        "In the event of a data breach, we will notify the relevant authorities within 72 hours and inform affected individuals if their personal data is compromised.",
      points: [
        {
          title: "Data Breach Response Plan:",
          items: [
            "Notify authorities within 72 hours.",
            "Inform affected individuals promptly.",
            "Mitigate and assess the breach to prevent future occurrences.",
          ],
        },
      ],
      note: "Data breach notification must follow strict timelines as per GDPR.",
    },
  ],
};
